import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { withTheme } from 'styled-components';
import { ExternalLink } from 'shared-components';
import { authEn,authFr } from '../../../../i18n/auth';


export default withTheme(({ theme }) => {
  const intl = useIntl();
  if (intl.locale === 'fr') {
    return (
      <ExternalLink
        href={theme.brand.activateElectronicComConsentFr}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage
          id="activate-electronic-com-consent-link"
          description="Label for Electronic Communication Consent"
          defaultMessage={authFr['activate-electronic-com-consent-link']}
        />
      </ExternalLink>
    );
  }
  return (
    <ExternalLink
      href={theme.brand.activateElectronicComConsentEn}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FormattedMessage
        id="activate-electronic-com-consent-link"
        description="Label for Electronic Communication Consent"
        defaultMessage={authEn['activate-electronic-com-consent-link']}
      />
    </ExternalLink>
  );
});
